export default function setHeaders(headers) {
    return {
        headers: {
            ...headers,
            "Accept": "application/json",
            'Content-Type': 'application/json',
        }
    };
}
